import { defineComponent as _defineComponent } from 'vue'
const _foo = "bar";

export default /*@__PURE__*/_defineComponent({
  __name: 'app-main-view',
  setup(__props, { expose: __expose }) {
  __expose();

// Shuts up an annoying error
// eslint-disable-next-line @typescript-eslint/no-unused-vars

const __returned__ = { _foo }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})